import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import history from 'app/routes/history';

import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import Flatpickr from 'react-flatpickr';

import { friendlyTime, superSimpleDate } from 'app/utils/parsers';
import Button from 'app/components/general/Button';
import Isvg from 'react-inlinesvg';
import TableFilter from 'app/components/general/TableFilter';

import TeammoLogo from 'app/images/logo-white.svg';
import ReportsIcon from 'app/images/icons/reports.svg';
import ListIcon from 'app/images/icons/list.svg';
import RefreshIcon from 'app/images/icons/refresh.svg';
import FilterIcon from 'app/images/icons/filter.svg';
import CalendarIcon from 'app/images/icons/events.svg';

import { getPaymentEventsByIdInSelectFormat } from 'app/ducks/paymentEvents/selectors';
import EventFilter from './EventFilter';

interface IEventDashboardControlTabletProps {
  parsedTime: string;
  orgName: string;
  toggleViewType: Function;
  toggleReport: Function;
  importButton: boolean;
  eventOnlyView: boolean;
  isLoading: boolean;
  handleChangeTime: Function;
  loadPaymentEvents: Function;
  handleFilterChange: Function;
  clearFilters: Function;
  applyFilters: Function;
  filterConfig: any;
  filterOptions: any;
  paymentEvents: any;
  match: any;
}

interface IEventDashboardControlTabletState {
  dropdownOpen: boolean;
  filterOpen: boolean;
  filterOptions: any;
}

export default class EventDashboardControlTablet extends React.Component<IEventDashboardControlTabletProps, IEventDashboardControlTabletState> {
  static defaultProps: IEventDashboardControlTabletProps = {
    orgName: undefined,
    toggleViewType: undefined,
    toggleReport: undefined,
    parsedTime: undefined,
    importButton: false,
    eventOnlyView: false,
    isLoading: false,
    handleChangeTime: undefined,
    loadPaymentEvents: undefined,
    filterOptions: undefined,
    paymentEvents: undefined,
    handleFilterChange: undefined,
    clearFilters: undefined,
    applyFilters: undefined,
    filterConfig: undefined,
    match: undefined,
  };

  state: IEventDashboardControlTabletState = {
    dropdownOpen: false,
    filterOpen: false,
    filterOptions: [],
  };

  static getDerivedStateFromProps(props, state): any {
    return {
      filterOptions: [
        {
          label: 'Venue',
          accessor: 'venue',
          type: 'select',
          isMulti: true,
          options: getPaymentEventsByIdInSelectFormat(props.paymentEvents),
        },
      ],
    };
  }

  toggle = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  toggleFilter = () => {
    this.setState((prevState) => ({
      filterOpen: !prevState.filterOpen,
    }));
  };

  toggleEventImport = () => {
    history.push('toggle');
  };

  logout = () => {
    history.push('/login');
  };

  refresh = () => {
    this.props.loadPaymentEvents();
  };

  render(): React.ReactNode {
    const simpleDate = superSimpleDate(this.props.parsedTime);
    return (
      <div>
        <div className="row event-dashboard-control-container event-dashboard-control-tablet">
          <div className="event-dashboard-control-tablet d-flex align-items-center">
            <div className="mr-auto d-flex align-items-center">
              <div className="logo-container d-flex align-items-center">
                <Isvg
                  className="event-dashboard-logo text-primary"
                  alt="Teammo"
                  src={TeammoLogo}
                />
              </div>
              <h3 className="text-black">{this.props.orgName || 'Matches'}</h3>
            </div>
            <div className="ml-auto d-flex align-items-center">
              <div className="event-dashboard-button-group">
                <div className="event-dashboard-button-subgroup">
                  <div className="event-dashboard-button">
                    <Dropdown
                      isOpen={this.state.dropdownOpen}
                      toggle={this.toggle}
                      direction="down"
                      className="event-dashboard-control-dropdown"
                    >
                      <DropdownToggle caret>
                        <Isvg src={CalendarIcon} className="calendar-icon" />
                        <span className="with-margin-left-5">{simpleDate}</span>
                      </DropdownToggle>
                      <DropdownMenu className="date-dropdown">
                        <Flatpickr
                          data-enable-time
                          className="form-control date-control-dropdown"
                          name="time"
                          value={this.props.parsedTime}
                          onChange={this.props.handleChangeTime}
                          defaultValue={new Date().toString()}
                          placeholder="Time"
                          // right={false}
                          aria-label="Time"
                          options={{
                            altInput: true,
                            altFormat: 'D j M Y - h:i K',
                            dateFormat: 'Z',
                            inline: true,
                          }}
                        />
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  <div className="event-dashboard-button">
                    <Button
                      onClick={this.refresh}
                      noLoading
                      className="btn-2 event-dashboard-button d-flex align-items-center"
                    >
                      <div className="d-flex align-items-left align-items-center">
                        <Isvg
                          className={classnames(
                            'refresh-icon d-flex align-items-center',
                            { loading: this.props.isLoading },
                          )}
                          src={RefreshIcon}
                        />
                        {' '}
                        <span className="button-text">Refresh</span>
                      </div>
                    </Button>
                  </div>
                </div>
                <div className="event-dashboard-button-subgroup">
                  <div className="event-dashboard-button">
                    <Button
                      onClick={this.props.toggleViewType}
                      noLoading
                      className={classnames('btn-2 event-dashboard-button d-flex align-items-center', { active: _.includes(this.props.match.path, 'event-dashboard/:eventDashboardId/list') })}
                    >
                      <div className="d-flex align-items-left align-items-center">
                        <Isvg
                          className="refresh-icon d-flex align-items-center"
                          src={ListIcon}
                        />
                        {' '}
                        <span className="button-text">List View</span>
                      </div>
                    </Button>
                  </div>
                  <div className="event-dashboard-button">
                    <Button
                      onClick={this.toggleFilter}
                      noLoading
                      className={classnames('btn-2 event-dashboard-button d-flex align-items-center', { active: !_.isEmpty(this.props.filterConfig) })}
                    >
                      <div className="d-flex align-items-left align-items-center">
                        <Isvg
                          className="refresh-icon d-flex align-items-center"
                          src={FilterIcon}
                        />
                        {' '}
                        <span className="button-text">Filter</span>
                      </div>
                    </Button>
                  </div>
                  <div className="event-dashboard-button">
                    <Button
                      onClick={this.props.toggleReport}
                      noLoading
                      className={classnames('btn-2 event-dashboard-button d-flex align-items-center', { active: this.props.match.path === '/event-dashboard/:eventDashboardId/report' })}
                    >
                      <div className="d-flex align-items-left align-items-center">
                        <Isvg
                          className="refresh-icon d-flex align-items-center"
                          src={ReportsIcon}
                        />
                        {' '}
                        <span className="button-text">Report</span>
                      </div>
                    </Button>
                  </div>
                </div>
                {/*
                <div className="event-dashboard-button">
                  {false && this.props.eventOnlyView && (
                    <Button
                      onClick={this.logout}
                      noLoading
                      className="btn-2 import-toggle"
                    >
                      Logout
                    </Button>
                  )}
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {this.state.filterOpen && (
          <div className="row event-dashboard-control-filter-container d-flex align-items-center">
            <h3>Filter by</h3>
            <EventFilter
              handleFilterChange={this.props.handleFilterChange}
              handleFilterToggleChange={this.handleFilterToggleChange}
              clearFilters={this.props.clearFilters}
              applyFilters={this.props.applyFilters}
              filterConfig={this.props.filterConfig}
              title="Filter"
              filterOptions={this.state.filterOptions}
            />
          </div>
        )}
      </div>
    );
  }
}
